import { formatProductType } from '@src/utils';
import type { ValueFormatterParams } from 'ag-grid-community';
import { get } from 'lodash-es';
import { baseColumn } from './baseColumn';
import type { ColDefFactory, Column } from './types';

/** Grabs the sub-product type from the value, or from the security associated with a symbol value. */
export const subProductType: ColDefFactory<Column> = column => ({
  ...baseColumn(column),
  valueGetter: ({ data, context }) => {
    if (data == null) {
      return '';
    }

    const value = column.field ? get(data, column.field) : data.Symbol;
    if (!value) {
      return '';
    }

    return context.current.securitiesBySymbol?.get(value)?.SubProductType ?? value;
  },
  valueFormatter: ({ value }: ValueFormatterParams<unknown, unknown>) => formatProductType(value),
});
